import { render, staticRenderFns } from "./entity-card-requests-detail-process-request-feedback.vue?vue&type=template&id=dd1e78ae&scoped=true&"
import script from "./entity-card-requests-detail-process-request-feedback.vue?vue&type=script&lang=js&"
export * from "./entity-card-requests-detail-process-request-feedback.vue?vue&type=script&lang=js&"
import style0 from "./entity-card-requests-detail-process-request-feedback.vue?vue&type=style&index=0&id=dd1e78ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1e78ae",
  null
  
)

export default component.exports